import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getTicketTypeById, getTicketTypeInfosByTicketTypeId } from "ticketino-api-client";
import parse from "html-react-parser";
import { motion } from "framer-motion";

import arrowRight from "../images/icons/arrow-right.svg";

import icon_mail from "../images/icons/payments/mail.svg"
import icon_printer from "../images/icons/payments/printer.svg"
import icon_paypal from "../images/icons/payments/paypal.svg"
import icon_mastercard from "../images/icons/payments/mastercard.svg"
import icon_visa from "../images/icons/payments/visa.svg"
import icon_amex from "../images/icons/payments/amex.svg"
import icon_twint from "../images/icons/payments/twint.svg"
import icon_postfinance from "../images/icons/payments/postfinance.svg"
import icon_invoice from "../images/icons/payments/invoice.svg"

import Header from "./components/Header";

const Checkout = () => {
    const [orderId] = useState(localStorage.getItem("orderId"));
    const [token] = useState(localStorage.getItem("token"));

    const [order, setOrder] = useState({});
    const [tickets, setTickets] = useState([]);
    const [payment, setPayment] = useState({
        paymentMethodId: 0,
        deliveryMethodId: 0,
        insurance: false
    })

    const [promotionCode, setPromotionCode] = useState("");
    const [promotionError, setPromotionError] = useState({
        text: "",
        valid: false
    });
    const [addedPromotionCodes, setAddedPromotionCodes] = useState([]);

    const [orderInsurancePrice, setOrderInsurancePrice] = useState(0);

    const [onlyInvoiceTickets, setOnlyInvoiceTickets] = useState(false);

    const [isAgbChecked, setIsAgbChecked] = useState(false);

    const [submitError, setSubmitError] = useState("");

    const eventName = localStorage.getItem("EventName");
    const eventDate = localStorage.getItem("EventDate");
    const eventStartTime = localStorage.getItem("EventStartTime");
    const eventCity = localStorage.getItem("EventCity");
    const eventLocation = localStorage.getItem("EventLocation");

    //const isButtonFinishOrderDisabled = payment.paymentMethodId === 0 || payment.deliveryMethodId === 0 || !isAgbChecked;
    const isButtonFinishOrderDisabled = payment.paymentMethodId === 0 || payment.deliveryMethodId === 0;

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});
    const [resourcesTranslation, setResourcesTranslation] = useState({});

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        // gtm - addPaymentInfo
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'addPaymentInfo'
        });
    }, [])

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        api.defaults.headers.common['Authorization'] = "Bearer " + token;

        if (orderId) {
            loadOrder(orderId);
            getOrderInsurance();
        }
    }, [orderId]); //gets called when an order is started

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.checkOut);
                setResourcesTranslation(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            const bookedTickets = updatedOrder.tickets;

            // Booked Tickets
            const updatedTickets = await Promise.all(
                bookedTickets.map(async (ticket) => {
                    const ticketType = await getTicketTypeById(ticket.ticketTypeId);

                    const info = await getTicketTypeInfosByTicketTypeId(ticket.ticketTypeId);
                    const ticketTypeInfo = info.find(info => info.languageId == languageId) ?? info[0];

                    return { ...ticket, ticketType: ticketType, info: ticketTypeInfo }
                })
            )

            let updatedPayment = { ...payment, deliveryMethodId: updatedOrder.deliveryMethodId, paymentMethodId: updatedOrder.paymentMethodId };

            updatedPayment.insurance = updatedOrder.totalInsuranceAmount > 0;

            setPayment(updatedPayment);
            setOrder(updatedOrder);
            setTickets(updatedTickets);

            const allInvoiceTickets = updatedTickets.every(t => t.ticketTypeId === 819445);
            setOnlyInvoiceTickets(allInvoiceTickets);
        }
        catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const onAgbChange = (isAgbChecked) => {
        setIsAgbChecked(isAgbChecked);
    };

    const changeDeliveryType = async (deliveryMethodId) => {
        await axios.put(
            `${baseUrl}/ShopBasket/Order/${orderId}/DeliveryMethod/${deliveryMethodId}`)
            .then(() => {
                loadOrder(orderId);
            })
            .catch((error) => {
                console.error(error.response.data);
            });
    };

    const changePaymentType = (paymentMethodId) => {
        axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/${paymentMethodId}`)
            .then((res) => {
                loadOrder(orderId);
            })
            .catch((error) => {
                console.error(error.response.data);
            });
    };

    const startDatatrans = () => {
        var baseRequestUrl = `https://datatrans.ticketino.com/Datatrans/${orderId}/DigitalSignature`;

        axios
            .get(baseRequestUrl)
            .then((res) => {
                let datatransFormId = "datatrans-" + new Date().getTime();
                var form =
                    "<form className='datatrans' id='" + datatransFormId + "'></form>";

                let container = document.getElementById("datatrans-form-placeholder");

                container.innerHTML += form;

                let element = document.getElementById(datatransFormId);

                // merchantId for testing
                // element.setAttribute("data-merchant-id", "1100004624");
                element.setAttribute("data-merchant-id", res.data.merchantId);
                element.setAttribute("data-amount", res.data.amount);
                element.setAttribute("data-currency", res.data.currency);
                element.setAttribute("data-refno", res.data.referenceNumber);
                element.setAttribute("data-reqType", res.data.reqType);
                element.setAttribute(
                    "data-upp-return-target",
                    res.data.uppReturnTarget
                );
                element.setAttribute("data-paymentMethod", res.data.paymentMethod);
                element.setAttribute("data-sign", res.data.digitalSignature);

                let domain = "https://" + window.location.host;

                let successUrl = domain + `/form/redirect/${language}/success/${orderId}`;
                let errorUrl = domain + `/form/redirect/${language}/error/${orderId}`;
                let cancelUrl = domain + `/form/redirect/${language}/cancel/${orderId}`;

                element.setAttribute("data-success-url", successUrl);
                element.setAttribute("data-error-url", errorUrl);
                element.setAttribute("data-cancel-url", cancelUrl);

                for (const key in res.data.userInfo) {
                    element.setAttribute(key, res.data.userInfo[key]);
                }

                for (const key in res.data.merchantSpecificParameters) {
                    element.setAttribute(key, res.data.merchantSpecificParameters[key]);
                }

                // start datatrans -> call the payment form
                window.Datatrans.startPayment({
                    form: "#" + datatransFormId,
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const onBackClick = async () => {
        navigate(-1)
    }

    // validate that the order still exists before payment process
    const validateOrderStillExists = async () => {
        try {
            const latest = await getOrderByOrderId(orderId);
            if (!latest) return false;
            if (!latest?.id) return false;
            if (!Array.isArray(latest?.tickets) || latest.tickets.length === 0) return false;
            return true;
        } catch (e) {
            return false;
        }
    }

    const onSubmit = async () => {

        setSubmitError("");

        const exists = await validateOrderStillExists();
        if (!exists) {
            setSubmitError(resources?.OrderExpiredMessage || "Your reservation is no longer available. Please start again.");
            return;
        }

        if (order?.totalPrice > 0) {
            let dataTransProviders = [1, 7, 8, 9, 10, 14];

            let datatransProvider = dataTransProviders.findIndex((d) => d === payment.paymentMethodId) !== -1

            if (datatransProvider) {
                startDatatrans();
            } else {
                await confirmShopbasketByOrderId(orderId);
                navigate(`/${language}/confirmation/${orderId}`);
            }
        } else {
            changePaymentTypeToFree();
        }
    }

    const getOrderInsurance = async () => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}/Insurance`);
            setOrderInsurancePrice(res.data);
        } catch (error) {
            console.error(error);
        }
    }

    const setOrderInsurance = async () => {
        await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Insurance`)
            .then(() => {
                loadOrder(orderId);
            }).catch((error) => {
                console.error(error);
            })
    }

    const removeOrderInsurance = async () => {
        await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/Insurance`)
            .then(() => {
                loadOrder(orderId);
            }).catch((error) => {
                console.error(error);
            })
    }

    const confirmShopbasketByOrderId = async (orderId) => {
        try {
            const res = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Confirm`);
            return res.data;
        } catch (error) {
            console.error(error)
        }
    };

    const changePaymentTypeToFree = () => {
        axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/5`)
            .then(async () => {
                await confirmShopbasketByOrderId(orderId);
                navigate(`/${language}/confirmation/${orderId}`);
            });
    }

    const mapTickets = () => {
        let ticketsSorted = [];

        if (tickets && tickets.length > 0) {
            ticketsSorted = [...tickets].sort((a, b) => a.id - b.id);
        }

        return (
            tickets &&
            tickets.length > 0 &&
            ticketsSorted.map((tt, index) => (
                <div key={tt.id}>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <div className="d-flex align-items-center flex-nowrap">
                            <label className="ticket-name-label mb-0">
                                1x {tt.info?.name}
                            </label>
                        </div>

                        <div className="d-flex align-items-center gap-2">
                            <label className="text-nowrap mb-0">
                                {tt.ticketType?.currency} {tt.ticketTypePrice.toFixed(2)}
                            </label>
                        </div>
                    </div>
                </div>
            ))
        );
    };

    const mapExtraCosts = () => {
        return (
            <div>
                <div className="row pt-2 pb-1">
                    <div className="col-md-8 col-8">
                        <label>{resources.DeliveryCosts}</label>
                    </div>
                    <div className="col-md-4 col-4 text-end">
                        <label>{order.currency + " " + order?.deliverPaymentFee.toFixed(2)}</label>
                    </div>
                </div>
            </div>
        )
    }

    const mapInsurance = () => {
        return (
            <div>
                <div className="row pt-2">
                    <div className="col-md-10 col-8">
                        <label>{resources.TicketInsurance}</label>
                    </div>
                    <div className="col-md-2 col-4 text-end">
                        <label>
                            {order.currency + " " + order.totalInsuranceAmount.toFixed(2)}
                        </label>
                    </div>
                </div>
            </div>
        )
    }

    const changeDeliveryTypeAndPaymentTypeToDefault = () => {
        axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/DeliveryMethod/1`).then((res) => {
                axios
                    .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/1`).then(() => {
                        // refresh the order values
                        // requestCompletedOrder();
                    }).catch((error) => {
                        console.error(error.response.data);
                    });
            }).catch((error) => {
                console.error(error.response.data);
            });
    }

    const promotionCodeElement = () => {
        return (
            <>
                <div className="row">
                    <div className="col-7 col-md-5">
                        <input
                            id="inputCode"
                            type="text"
                            name="promotionCode"
                            className="form-control form-control-promocode"
                            placeholder={resources.PromotionPlaceholder}
                            value={promotionCode}
                            onChange={(e) => setPromotionCode(e.target.value)}
                        />
                    </div>
                    <div className="col-4">
                        <button
                            className="btn-custom-promocode"
                            onClick={() => applyPromotionCode()}
                            disabled={promotionCode === ""}
                        >
                            {resources.Rendeem}
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 mt-2">
                        {!promotionError.valid ? <p className="text-danger fs-6">
                            {promotionError.text}
                        </p> :
                            <p className="text-success fs-6">
                                {promotionError.text}
                            </p>}
                    </div>
                </div>
            </>
        );
    };

    const applyPromotionCode = () => {
        axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${promotionCode}`)
            .then(async () => {
                setPromotionError({
                    text: `${resources.PromocodeSuccess} (${promotionCode})`,
                    valid: true
                });

                try {
                    // fetch promotion details
                    const resPromotion = await axios.get(
                        `${baseUrl}/PromotionCode/${promotionCode}/Promotion`,
                        {
                            params: { organizerId: 1826696 }
                        }
                    );

                    let discountFromOrder = resPromotion.data?.discount;
                    let discountSymbol = "-";

                    if (resPromotion.data?.isDiscountInPercentage) {
                        discountSymbol = "%";
                        discountFromOrder = order.total * (resPromotion.data?.discount / 100);
                    }

                    // Add object with extra info
                    setAddedPromotionCodes((current) => [
                        ...current,
                        {
                            code: promotionCode,
                            discount: resPromotion.data?.discount ?? null,
                            discountSymbol: discountSymbol,
                            discountFromOrder: discountFromOrder
                        }
                    ]);
                } catch (err) {
                    console.error("Failed to fetch promotion details", err);

                    // fallback: still add just the code
                    setAddedPromotionCodes((current) => [
                        ...current,
                        { code: promotionCode }
                    ]);
                }

                changeDeliveryTypeAndPaymentTypeToDefault();
                loadOrder(orderId);
            })
            .catch(() => {
                setPromotionError({
                    text: resources.PromocodeError,
                    valid: false
                });
            });
    };

    const removePromotionCode = (code) => {
        axios
            .delete(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${code}`)
            .then(() => {
                setAddedPromotionCodes((current) =>
                    current.filter((item) => item.code !== code)
                );

                setPromotionError({ text: "", valid: false });
                loadOrder(orderId);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const mapAddedPromotionCodes = () => {
        return (
            <div>
                {addedPromotionCodes.map((item, index) => (
                    <div className="row" key={index}>
                        <div className="col-md-6 text-success">
                            {item.code} ({item.discountSymbol || ""} {item.discount || "Promotion code"})

                            {/*<button*/}
                            {/*    className="blank-button"*/}
                            {/*    onClick={() => removePromotionCode(item.code)}*/}
                            {/*>*/}
                            {/*    ({resources.Remove})*/}
                            {/*</button>*/}
                        </div>
                        <div className="col-md-6 text-success text-end">
                            - CHF {item.discountFromOrder.toFixed(2) || ""}
                        </div>
                    </div>
                ))}
            </div>
        );
    };


    return (
        <>
            <div id="datatrans-form-placeholder"></div>

            <Header
                language={language}
                pagePath="checkout"
                eventName={eventName}
                eventDate={eventDate}
                eventStartTime={eventStartTime}
                eventCity={eventCity}
                eventLocation={eventLocation}
            />

            <motion.div
                className="page-container"
                initial={{ opacity: 0, y: 30 }}   // start: invisible + lower
                animate={{ opacity: 1, y: 0 }}    // end: visible + in place
                transition={{ duration: 0.5, ease: "easeOut", delay: 0.8 }}
            >
                <div className="container wrapper">

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <p className="text-subtitle text-blue">{resources.Promocode}</p>
                        </div>
                    </div>
                    <div className="tickets-box p-4 pb-0 pt-4">
                        <div className="row">
                            <div className="col-md-12">
                                <p>{resources.PromocodeDescription}</p>
                            </div>
                        </div>

                        <div className="row">
                            <div>{promotionCodeElement()}</div>
                        </div>

                        <div style={{ height: '10px' }}></div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-md-12">
                            <p className="text-subtitle text-blue">{resources.DeliveryOption}</p>
                        </div>
                    </div>

                    <div className="tickets-box p-4 pb-0 pt-4">
                        <div className="mb-4">
                            <div className="form-check mb-3">
                                <input
                                    className="form-check-input me-2"
                                    type="radio"
                                    name="flexRadioDefault1"
                                    checked={payment.deliveryMethodId === 1 ? true : false}
                                    onClick={() => changeDeliveryType(1)}
                                    id="printAtHome"
                                />
                                <label
                                    className="d-inline"
                                    htmlFor="printAtHome"
                                >
                                    {/*<img htmlFor="mail" src={icon_mail} className="delivery_icon" alt="Mail Icon" />*/}
                                    {resources.PrintAtHome}
                                    <p className="text-secondary delivery-description">
                                        {resources.PrintAtHomeDescription}
                                    </p>
                                </label>
                            </div>

                            <div style={{ height: '10px' }}></div>
                        </div>
                    </div>
                    {
                        order.totalPrice > 0 &&
                        <>
                            <div className="row mt-5">
                                <div className="col-md-12">
                                    <p className="text-subtitle text-blue">{resources.PaymentOption}</p>
                                </div>
                            </div>

                            <div className="tickets-box p-4 pb-0 pt-4">
                                <div className="mb-5">
                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input me-2"
                                            type="radio"
                                            name="flexRadioDefault"
                                            checked={payment.paymentMethodId === 1 ? true : false}
                                            onClick={() => changePaymentType(1)}
                                            id="mastercard"
                                        />
                                        <label
                                            className="d-inline payment-names"
                                            htmlFor="mastercard"
                                        >
                                            {/*<img src={icon_mastercard} className="payment_icon" alt="Mastercard Icon" />*/}
                                            {resources.MasterCard}
                                            <p className="text-secondary payment-description">
                                                {resources.MasterCardDesc}
                                            </p>
                                        </label>
                                    </div>

                                    <div className="form-check mb-3 mt-4">
                                        <input
                                            className="form-check-input me-2"
                                            type="radio"
                                            name="flexRadioDefault"
                                            checked={payment.paymentMethodId === 7 ? true : false}
                                            onClick={() => changePaymentType(7)}
                                            id="visa"
                                        />
                                        <label
                                            className="d-inline payment-names"
                                            htmlFor="visa"
                                        >
                                            {/*<img src={icon_visa} className="payment_icon" alt="Visa Icon" />*/}
                                            {resources.Visa}
                                            <p className="text-secondary payment-description">
                                                {resources.VisaDesc}
                                            </p>
                                        </label>
                                    </div>

                                    {/*<div className="form-check mb-3 mt-4">*/}
                                    {/*    <input*/}
                                    {/*        className="form-check-input me-2"*/}
                                    {/*        type="radio"*/}
                                    {/*        name="flexRadioDefault"*/}
                                    {/*        checked={payment.paymentMethodId === 8 ? true : false}*/}
                                    {/*        onClick={() => changePaymentType(8)}*/}
                                    {/*        id="amex"*/}
                                    {/*    />*/}
                                    {/*    <label*/}
                                    {/*        className="d-inline payment-names"*/}
                                    {/*        htmlFor="amex"*/}
                                    {/*    >*/}
                                    {/*        <img src={icon_amex} className="payment_icon" alt="Amex Icon" />*/}
                                    {/*        {resources.AmericanExpress}*/}
                                    {/*        <p className="m-0 text-secondary payment-description">*/}
                                    {/*            */}{/*{resources.AmericanExpressDesc}*/}
                                    {/*        </p>*/}
                                    {/*    </label>*/}
                                    {/*</div>*/}

                                    <div className="form-check mb-3">
                                        <input
                                            className="form-check-input me-2"
                                            type="radio"
                                            name="paypal"
                                            checked={payment.paymentMethodId === 10 ? true : false}
                                            onClick={() => changePaymentType(10)}
                                            id="paypal"
                                        />

                                        <label
                                            className="d-inline payment-names"
                                            htmlFor="paypal"
                                        >
                                            {/*<img htmlFor="paypal" src={icon_paypal} className="payment_icon" alt="Paypal Icon" />*/}
                                            {resources.PayPal}
                                            <p className="text-secondary payment-description">
                                                {resources.PayPalDesc}
                                            </p>
                                        </label>
                                    </div>

                                    <div className="form-check mb-3 mt-4">
                                        <input
                                            className="form-check-input me-2"
                                            type="radio"
                                            name="flexRadioDefault"
                                            checked={payment.paymentMethodId === 9 ? true : false}
                                            onClick={() => changePaymentType(9)}
                                            id="postfinance"
                                        />
                                        <label
                                            className="d-inline payment-names"
                                            htmlFor="postfinance"
                                        >
                                            {/*<img src={icon_postfinance} className="payment_icon" alt="Postfinance Icon" />*/}
                                            {resources.PostFinance}
                                            <p className="text-secondary payment-description">
                                                {resources.PostFinanceDesc}
                                            </p>
                                        </label>
                                    </div>

                                    <div className="form-check mb-3 mt-4">
                                        <input
                                            className="form-check-input me-2"
                                            type="radio"
                                            name="flexRadioDefault"
                                            checked={payment.paymentMethodId === 14 ? true : false}
                                            onClick={() => changePaymentType(14)}
                                            id="twint"
                                        />
                                        <label
                                            className="d-inline payment-names"
                                            htmlFor="twint"
                                        >
                                            {/*<img src={icon_twint} className="payment_icon" alt="Twint Icon" />*/}
                                            {resources.Twint}
                                            <p className="text-secondary payment-description">
                                                {resources.TwintDesc}
                                            </p>
                                        </label>
                                    </div>

                                    {/*{onlyInvoiceTickets &&*/}
                                    {/*<div className="form-check mb-3 mt-4">*/}
                                    {/*    <input*/}
                                    {/*        className="form-check-input me-2"*/}
                                    {/*        type="radio"*/}
                                    {/*        name="flexRadioDefault"*/}
                                    {/*        checked={payment.paymentMethodId === 2 ? true : false}*/}
                                    {/*        onClick={() => changePaymentType(2)}*/}
                                    {/*        id="invoice"*/}
                                    {/*    />*/}
                                    {/*    <label*/}
                                    {/*        className="d-inline payment-names"*/}
                                    {/*        htmlFor="invoice"*/}
                                    {/*    >*/}
                                    {/*        <img src={icon_invoice} className="payment_icon" alt="Invoice Icon" />*/}
                                    {/*        {resources.PaymmentInvoice}*/}
                                    {/*        <p className="m-0 text-secondary payment-description">*/}
                                    {/*            */}{/*{resources.PaymentSmallFee}*/}
                                    {/*        </p>*/}
                                    {/*    </label>*/}
                                    {/*</div>*/}
                                    {/*}*/}

                                    <div style={{ height: '20px' }}></div>
                                </div>
                            </div>
                        </>
                    }

                    {order.totalPrice > 0 &&
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                {/*<p className="text-subtitle text-blue mb-2">{resources.TicketInsurance}</p>*/}
                                <div className="form-check mb-4">
                                    <input
                                        id="chk-insurance"
                                        className="form-check-input me-3 "
                                        type="checkbox"
                                        checked={payment.insurance}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setOrderInsurance();
                                            } else {
                                                removeOrderInsurance();
                                            }
                                        }}
                                    />
                                    <label className="col-11 form-check-label fs-6" htmlFor="chk-insurance">
                                        {parse(
                                            (orderInsurancePrice === 0
                                                ? resources.TicketInsuranceDescGeneric
                                                : (resources.TicketInsuranceDesc ?? "").replace("{@InsurancePrice}", orderInsurancePrice.toFixed(2))
                                            ) ?? ""
                                        )}
                                    </label>
                                </div>

                            </div>
                        </div>}

                    <div className="row">
                        <div className="col-md-12">
                            <p className="text-subtitle text-blue">{resources.Summary}</p>
                        </div>
                    </div>

                    <div className="tickets-box-blue p-4 pb-2 pt-2">
                        <div className="row">
                            <div className="col-md-12">
                                <>
                                    {mapTickets()}

                                    <hr className="ticket-separator-white" />

                                    {payment.insurance && mapInsurance()}
                                    {order.deliverPaymentFee > 0 && mapExtraCosts()}
                                    {mapAddedPromotionCodes()}

                                    <div className="row mt-1 mb-3">
                                        <div className="col-md-8 col-8">
                                            <span className="text-subtitle">
                                                {resources.Total}
                                            </span>
                                        </div>
                                        <div className="col-md-4 col-4 text-end">
                                            <span className="text-subtitle">
                                                {order.currency} {order.totalPrice?.toFixed(2)}
                                            </span>
                                        </div>
                                    </div>
                                </>
                            </div>
                        </div>
                    </div>

                    {/* AGB */}
                    {/*<div className="row mt-5" onClick={() => onAgbChange(!isAgbChecked)}>*/}
                    {/*    <div className="col-1 ps-md-4 fs-5 text-secondary">*/}
                    {/*        <i className={`bi bi${(isAgbChecked) ? "-check" : ""}-square`}></i>*/}
                    {/*    </div>*/}
                    {/*    <div className="col-11 col-md-10 ps-md-0">*/}
                    {/*        <label style={{ marginTop: "2px" }} dangerouslySetInnerHTML={{ __html: resources?.AGB }}></label>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    
                    {/* Buttons */}
                    <div className="row mt-5">
                        {/*<div className="col-6">*/}
                        {/*    <button className="btn btn-custom" onClick={() => onBackClick()}>{resources?.Back}</button>*/}
                        {/*</div>*/}
                        <div className="col-12 text-end">
                            <button className="btn-custom-checkout-arrow me-3" disabled={isButtonFinishOrderDisabled} onClick={() => onSubmit()}>
                                <img src={arrowRight} alt="Finish booking" style={{ marginTop: "-3px", marginLeft: "4px", width: "10px", height: "12px" }} />
                            </button>
                            <button className="btn-custom-checkout" disabled={isButtonFinishOrderDisabled} onClick={() => onSubmit()}>
                                {order.total > 0 ? resources?.Buy : resources?.BuyFree}
                            </button>
                        </div>
                    </div>                                     

                    {submitError && (
                        <div className="row mt-3">
                            <div className="col-12">
                                <div className="alert alert-danger" role="alert">
                                    {submitError}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="row mt-5">
                        <div className="col-md-12 text-center">
                            <p className="mt-4">
                                <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none', fontSize: '13px' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                            </p>
                        </div>
                    </div>
                </div>
            </motion.div>
        </>
    )
}

export default Checkout